// Copyright (c) Facebook, Inc. and its affiliates. All Rights Reserved

import { css } from 'emotion';
import React, { useState, useEffect } from 'react';
import dateFormat from 'dateformat';
import { useSelector, useDispatch } from 'react-redux'
// import { useSelector, useDispatch } from 'react-redux'
// import { createRoute } from '../actions';
import Autocomplete from 'react-autocomplete'
import { ConfirmationDialog } from './Dialog'
import MainMap from './MapNew'
import { getOrdersWithRef, postCreateRoute } from '../api/githubAPI';
import { navigate } from 'hookrouter';
import { COLOR, loadMarkers } from '../const'
import { loadRoutes } from '../actions';


const CreateNewRoute = (): JSX.Element => {

  const dispatch = useDispatch();
  const reroute: any = useSelector((state: any) => state.Route.createroute)
  const routes: any = useSelector((state: any) => state.Route.routes)

  const [route, setRoute] = useState(routes)
  const [del, setDel] = useState(reroute.orders.length)
  const { height, width } = useWindowDimensions();

  const [showConfirm, setConfirm] = useState(false)
  const [showlist, setShowlist] = useState(false)
  const [listOrder, setListOrder] = useState<any>([])
  const [valcomplete, setcomplete] = useState('')
  const [issuesError, setIssuesError] = useState<Error | null>(null)
  // const dispatch = useDispatch();


  const datedilevery = new Date();

  const handleCancel = async () => {
    setConfirm(false)
    navigate('/route')
  }

  useEffect(() => {
    showListOrder()
  }, [])

  useEffect(() => {
    // setRoute(reroute.orders)
    dispatch(loadRoutes(route))
    console.log('useEffect', route)
  }, [route, del])
  console.log(routes)

  useEffect(() => {
    setRoute(routes)
    console.log('useEffect', routes)
  }, [routes])



  const showListOrder = async () => {
    // console.log('showListOrder');

    async function fetchListOrder() {
      async function fetchList() {
        const OrdersResult: any = await getOrdersWithRef(reroute.ref)
        // const OrdersResult: any = await getOrdersWithRef('z10r72lbbgiq3409iwsj')
        setListOrder(OrdersResult.orders)
        console.log('OrdersResult', OrdersResult.orders)
      }

      try {
        await Promise.all([fetchList()])
        setIssuesError(null)
      } catch (err) {
        console.error(err)
        setIssuesError(err)
      }
    }
    fetchListOrder()


  }

  // const setallOrder = async () => {

  //   for (let index = 0; index < listOrder.length; index++) {
  //     const element: any = listOrder[index];
  //     HiItems(element.no)
  //   }

  // }


  const callCreateRoute = async () => {
    // console.log('call Create Route');

    async function fetchCreate() {
      const arr_route = []
      for (let index = 0; index < route.length; index++) {
        const element: any = route[index];
        arr_route.push(element.no)
      }

      const body = {
        ref: reroute.ref,
        // ref: 'z10r72lbbgiq3409iwsj',
        route: arr_route
      }
      // console.log('reroute', reroute)
      await postCreateRoute(body)
      // console.log('RouteResult', RouteResult)
    }


    try {
      await Promise.all([fetchCreate(), dispatch(loadRoutes([]))])

      setIssuesError(null)
      navigate('/route')
    } catch (err) {
      console.error(err)
      setIssuesError(err)
    }
  }

  const delOrderFromRoute = async (index: number) => {
    route.splice(index, 1);
    await Promise.all([
      setDel(del - 1)
    ])
  }

  const HiItems = (items: string) => {
    setcomplete(items)
    const tmp: any = listOrder.filter((element: any) => {
      return (element.no === items)
    });
    const check = route.filter((element: any) => {
      return (element.no === tmp[0].no)
    });
    if (check.length !== 0) {
      return;
    }
    console.log(tmp)
    setDel(del + 1)
    route.push(Object.assign(tmp[0], { new: true }));
    setcomplete('')
  }

  const handleDrop = async () => {
    await Promise.all([
      showListOrder(),
      setShowlist(true)
    ])
  }

  const handleclick = (item: string) => {

    // dispatch(addRoute(route[i]))

    const tmp: any = listOrder.filter((element: any) => {
      return (element.no === item)
    });

    const check = route.filter((element: any) => {
      return (element.no === tmp[0].no)
    });
    if (check.length !== 0) {
      return;
    }
    const new_route = [].concat(routes, Object.assign(tmp[0], { new: true }))
    console.log('handleclick', new_route)
    dispatch(loadRoutes(new_route))
  }

  if (issuesError) {
    return (
      <div>
        <h1>Something went wrong...</h1>
        <div>{issuesError.toString()}</div>
      </div>
    )
  }

  // if (reroute.orders.length === 0) {
  //   navigate('/route')
  //   return (<div>
  //     <h1>Something went wrong...</h1>
  //     <div>Redirect to Route List</div>
  //   </div>)
  // }


  const RouteRow = (routes: Array<any>) => {
    console.log('RouteRow', routes)
    return (
      <div className={styles.routeRow}>
        <ul className={styles.circleBar}>
          {new Array(routes.length).fill(null).map((_, index: number) => (
            <li key={index} style={{ background: routes[index].new !== undefined ? '#FFF8E7' : '#ffffff' }}>
              <div key={index} className={styles.columnList} style={{ background: routes[index].new !== undefined ? '#FFF8E7' : '#ffffff' }}>
                <div key={index} className={styles.textCircle}>
                  {routes[index].no}
                  <a className={styles.btnCoppy} onClick={() => { delOrderFromRoute(index) }}>
                    <i className="icon-close" />
                  </a>
                </div>
                <div className={styles.textCircle}>
                  {`ผู้ส่งสินค้า:`}{routes[index].contact.name},{routes[index].contact.mobile}
                </div>
                <div className={styles.textAddess}>
                  {routes[index].address}
                </div>
              </div>
            </li>
          ))}
        </ul>
      </div>
    );
  }




  const styles = {
    root: css`
    height:  ${height - 80}px;
    width: 100%;
    display: flex;
    padding-top: 35px;
    width: 600px;
    position: relative;
  `,
    divWrap: css`
  position: relative;
  `,
    btnCoppy: css`
  cursor: pointer;
  padding:0 0 5px 5px;
  display: inline-block;
  font-weight: 400;
  text-align: center;
  vertical-align: middle;
  -webkit-user-select: none;
  user-select: none;
  background-color: transparent;
  border: 1px solid transparent;
  border-radius: 13px;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
   i{
    font-size: 18px;
    color:${COLOR['YELLOW_1']};
   }
   &:focus{
    box-shadow: none;
    outline: none;
   }
  `,
    columnList: css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    padding-left:15px;
    padding-bottom:15px;
  `,
    circleBar: css`
  counter-reset: step;
  margin:0;
  padding:0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  li{
    display: flex;
    flex-direction: row;
    float: left;
    position: relative;
    text-align: left;
    list-style: none;
    line-height: 28px;
    width: 460px;
    &:last-child{
      &:after{
        content: none;
      }
    }
    &:before{
      content:counter(step);
      counter-increment: step;
      min-width: 30px;
      min-height: 30px;
      max-width: 30px;
      max-height: 30px;
      border: 2px solid ${COLOR['BLUE_DARK']};
      display: block;
      margin: 0 auto 10px auto;
      border-radius: 50%;
      line-height: 27px;
      background: white;
      color: ${COLOR['BLUE_DARK']};
      text-align: center;
      font-size: 16px;
      z-index: 999999;
      margin-top: 30px;
      margin-left: 30px;
    }
    &:after{
      content: '';
      position: absolute;
      width:3px;
      height:100%;
      background: ${COLOR['BLUE_DARK']};
      top: 33px;
      left: 16px;
      z-index: 9999;
      margin-left: 30px;
    }
  }
  `,
    from: css`
  height: ${height - 80}px;
  flex-grow: 2;
  // width: 600px;
  background: #fff;
  box-shadow: 1px 0px 3px rgba(0, 0, 0, 0.13);
  border-radius: 0px 23px 23px 0px;
  width: 600px;
  z-index: 999;
  `,
    map: css`
  height: ${height - 80}px;
  width: ${width - 700}px;
  flex-grow: 8;
  background: rgba(0, 181, 0, 0.05);
  position: absolute;
  top: 35px;
  right: 0;
  `,
    class: css`

  `,
    divTable: css`
    display: table;
    width: 100%;
    `,
    divRow: css`
  display: table-row;
  background-color: #ffffff;
  `,
    divCell: css`
  display: table-cell;
    padding: 3px 10px;
    text-align: center
  `,
    divMap: css`
  height: 600px;
  width: 600px;
  background: rgba(0, 181, 0, 0.05);
  `,
    scoller: css`
  height: ${window.innerHeight - 170}px;
  overflow: scroll;
  position: relative;
  `,
    routeRow: css`;
    height: 100%;
    // width: 600px;
    display: flex;
    flex-direction: column;
    // padding: 15px;
    box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.13);
    `,
    divCircle: css`;
    height: 60px;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: start;
    `,
    divText: css`;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    `,
    itemCircle: css`
    height: 100%;
    width: 90px;
    display: flex;
  justify-content: center;
    `,
    routeCircle: css`
    height: 35px;
    width: 35px;
    border: solid 1px #000;
    border-radius: 35px;
    display: flex;
  justify-content: center;
  align-items: center;
    `,
    textCircle: css`
    font-weight: bold;
    font-size: 18px;
    width: 550px;
    `,
    textAddess: css`
    font-size: 18px;
    width: 100%;
    `,
    footer: css`
    width: 600px;
    background: #FFFFFF;
    height: 50px;
  `,
    buttonClose: css`
    float: left;
  // position: absolute;
    line-height: 40px;
    color: #fff;
    font-size: 18px;
    font-weight: bold;
    width: 100px;
    height: 40px;
    background: #444966;
    border-radius: 13px;
    bottom: 20px;
    left: 30px;
    text-align: center;
    cursor: pointer;
    margin-left: 20px;
  `,
    buttonCancel: css`
    position: absolute;
    line-height: 40px;
    color: #E54363;
    font-size: 18px;
    font-weight: bold;
    width: 180px;
    height: 40px;
    background: #FFFFFF;
    border-radius: 13px;
    bottom: 20px;
    left: 189px;
    text-align: center;
    cursor: pointer;
    
  `,
    buttonReroute: css`
    float: right;
    // position: absolute;
    line-height: 40px;
    color: #444966;
    font-size: 18px;
    font-weight: bold;
    width: 180px;
    height: 40px;
    background: #FDB513;
    border-radius: 13px;
    bottom: 20px;
    left: 389px;
    text-align: center;
    cursor: pointer;
    margin-right: 20px;
  `,
    divHeader: css`
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: #FFFFFF;
  border-radius: 0px 23px 0px 0px;
  color:#ffffff;
  // font-family: system-ui;
  box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.13);
  `,
    divTitle: css`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding:15px 15px;
`,
    textHeader: css`
  color: ${COLOR['BLUE_DARK']};
  font-weight: bold;
  font-size: 18px;
  padding-bottom:10px;
  `,
    textTitle: css`
  color: ${COLOR['BLUE_DARK']};
  font-size: 18px;
  `,
    divDetail: css`
  display: flex;
  flex-direction: column;
  max-height: 80vh;
  overflow-y: scroll;
`,
    flexRow: css`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    padding: 15px;
    `,
    hedaerNote: css`
    font-size: 20px;
    font-weight: bold;
    color: ${COLOR['BLUE_DARK']};
    // padding: 15px 0 15px 15px;
    `,
    noteDetail: css`
    font-size: 18px;
    color: ${COLOR['DARK_2']};
    text-align: center;
    width: 100%;
    padding:30px 0;
    `,
    flexRowAdd: css`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.13);
    input{
    width: 150px;
    display: block;
    padding: 5px 6px;
    margin: 15px;
    font-size: 14px;
    font-weight: 400;
    line-height: 14px;
    color: #242D31;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid rgba(68,73,102,0.1);
    border-radius: 7px;
    -webkit-transition: border-color 0.15s ease-in-out,box-shadow 0.15s ease-in-out;
    transition: border-color 0.15s ease-in-out,box-shadow 0.15s ease-in-out;
    box-sizing: border-box;
    &:focus{
      box-shadow: none;
      outline: none;
     }
    }
    a{
      padding: 15px;
      font-weight: bold;
      font-size: 20px;
      color:${COLOR['YELLOW_1']};
      width: 600px;
      box-sizing: content-box;
      cursor: pointer;
      display: flex;
      align-items: center;
      i{
        padding-right: 10px;
        font-size: 30px;
      }
    }
  `,
    dropDown: css`
  box-sizing: border-box;
  max-width: 530px;
  border-radius: 7px;
  `,
    dropDownTtem: css`
  padding: 5px 10px;
  cursor: pointer;
  background-color: #ffffff;
  &:nth-child(1) {
    border-radius: 7px;
  }
  &:hover{
    background-color: rgba(253,181,19,0.5);
  }
  `,
  };

  return (
    <div className={styles.divWrap}>
      <div className={styles.root}>
        <div className={styles.from}>
          <div className={styles.divHeader}>
            <div className={styles.divTitle}>
              <div>
                <div className={styles.textHeader}>DELIVERY DATE</div>
                <div className={styles.textTitle}>{dateFormat(datedilevery, "ddd dd-mm-yyyy")}</div>
              </div>
              <div>
                <div className={styles.textHeader}>ROUTE</div>
                <div className={styles.textTitle}>reroute</div>
              </div>
            </div>
          </div>

          <div className={styles.scoller}>
            <div className={styles.class}>
              {RouteRow(route)}
            </div>
            <div className={styles.flexRowAdd}>
              {(showlist === true) ? <Autocomplete

                menuStyle={{ border: '1px solid rgba(68,73,102,0.1)', borderRadius: '7px', padding: '0', width: '530px', maxHeight: '200px', overflowY: 'scroll', zIndex: 999999999999, }}
                getItemValue={(item) => item.no}
                items={listOrder}
                renderItem={(item, isHighlighted) =>
                  <div key={item._id} className={styles.dropDown}>
                    <div className={styles.dropDownTtem}>
                      {item.no} {item.contact.name} {item.contact.mobile} {item.address}
                    </div>
                  </div>
                }
                value={valcomplete}
                onChange={(e: any) => setcomplete(e.target.value)}
                onSelect={(val) => HiItems(val)}
              /> : <a onClick={() => { handleDrop() }}><i className="icon-plus" />Add Drop off</a>}
            </div>
            <div className={styles.flexRow}>
              <div className={styles.hedaerNote}>หมายเหตุถึงคนขับ</div>
              <div className={styles.noteDetail}>ROUTE</div>
            </div>

            <div className={styles.footer}>
              <div className={styles.buttonClose} onClick={() => { setConfirm(true) }}>CANCEL</div>
              {/* <div className={styles.buttonClose} onClick={() => { setallOrder() }}>List</div> */}
              <div className={styles.buttonReroute} onClick={() => { callCreateRoute() }}>REROUTE</div>
            </div>
          </div>


          <ConfirmationDialog
            open={showConfirm}
            title={'CANCEL'}
            variant={'danger'}
            description={'are you sure leave this page'}
            onSubmit={handleCancel}
            onClose={() => { setConfirm(false) }}
          />
        </div>
      </div>
      <div className={styles.map}>
        <MainMap zoom={12} route={loadMarkers(listOrder)} clickMarker={handleclick} />
      </div>
    </div>
  );



}


function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height
  };
}
const useWindowDimensions = () => {
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return windowDimensions;
}








export default CreateNewRoute;
